import React, { useEffect } from 'react'
import useMovimentacaoPorTipoOperacao, { LOAD_MESSAGE } from './MovimentacaoPorTipoOperacaoHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import {
  CustomDataTableHeader,
  CustomDropdown,
  CustomDropdownWithFilter,
  CustomMultiSelect,
  CustomPanel,
  NumeroDecimal,
  PageHeader,
  Periodo,
} from '../../../../components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { tableCellCentered } from '../../../../assets/js/styles'
import { SplitButton } from 'primereact/splitbutton'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

function MovimentacaoPorTipoOperacao({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useMovimentacaoPorTipoOperacao()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    if (state.pathToRedirect) {
      history.push(state.pathToRedirect, { selectedInventario: state.selectedInventario })
    }
  }, [state.pathToRedirect])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_INFORMACOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  function switchTypeDatatable(selectedGrupoOperacao) {
    if (selectedGrupoOperacao) {
      const selectDataTable = {
        'Recebimento': <DataTableOperacaoEntrada state={state} localDispatch={localDispatch} />,
        'Expedicao': <DataTableOperacaoExpedicao state={state} localDispatch={localDispatch} />,
        'Inventario': <DataTableOperacaoInventarioAvulso state={state} localDispatch={localDispatch} />,
        'Avulso': <DataTableOperacaoInventarioAvulso state={state} localDispatch={localDispatch} />,
      }

      if (selectDataTable[selectedGrupoOperacao.value])
        return selectDataTable[selectedGrupoOperacao.value]

      return <div>O relatório está em processo de homologação para esse tipo de operação.</div>
    }
  }

  function getExportData() {
    const grupoOperacao = state.selectedGrupoOperacao.value
    if (grupoOperacao === 'Recebimento') {
      const headers = ['Data da Operação', 'Numero NF', 'Qte Volumes', 'Qte Pallet', 'Qte Pallet Remontado', 'Peso Total em KG', 'Placa']
      const rows = state.rows.map(row => [row.data_movimentacao, row.invoice_number, row.qte_volumes, row.qte_pallets, row.qte_pallets_remontado, row.peso_total, row.placa])
      return [headers, ...rows]
    } else if (grupoOperacao === 'Expedicao') {
      const headers = ['Data da Operação', 'Carga Batida', 'Identificador', 'Qte Volumes', 'Qte Pallets', 'Peso Total em KG']
      const rows = state.rows.map(row => [row.data_operacao, row.carga_batida ? 'Sim' : 'Não', row.identifier, row.qte_volumes, row.qte_pallets, row.peso_total])
      return [headers, ...rows]
    } else {
      const headers = ['Data da Operação', 'Produto', 'Data de Validade', 'Lote', 'Operação de Estoque', 'Estoque', 'Quantidade']
      const rows = state.rows.map(row => [row.data_movimentacao, row.product_name, row.data_validade, row.lote, row.operacao_name, row.estoque_name, row.quantidade])
      return [headers, ...rows]
    }
  }

  function onExportExcel() {
    gerarArquivoExcel('Movimentações', getExportData(), 'movimentacoes_tipo_operacao.xlsx')
  }

  function onExportCSV() {
    const [headers, ...dataRows] = getExportData()
    const escapeField = value => {
      if (value === null || value === undefined) return '""'
      const str = String(value)
      return typeof value === 'string' ? `"${str.replace(/"/g, '""')}"` : str
    }
    const csvLines = [
      headers.join(','),
      ...dataRows.map(row => row.map(escapeField).join(',')),
    ]
    const csvContent = csvLines.join('\n')
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'movimentacoes_tipo_operacao.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  const exportItems = [
    {
      label: 'Exportar CSV',
      command: onExportCSV,
    },
  ]

  return (
    <div>
      <PageHeader>8.10 - Movimentações por Tipo de Operação de Estoque</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <React.Fragment>
            <div className="p-grid">
              <div className="p-col-3">
                <CustomDropdownWithFilter
                  label={'Empresa'}
                  value={state.selectedEmpresa}
                  optionLabel={'name'}
                  options={state.empresas}
                  filter={true}
                  onChange={value => localDispatch.onChange('selectedEmpresa', value)}
                />
              </div>
              <div className="p-col-3">
                <CustomDropdown
                  label={'Grupo de Operação'}
                  optionLabel={'name'}
                  value={state.selectedGrupoOperacao}
                  options={[
                    { name: 'Recebimento', value: 'Recebimento' },
                    { name: 'Expedição', value: 'Expedicao' },
                    { name: 'Inventario', value: 'Inventario' },
                    { name: 'Avulso', value: 'Avulso' },
                  ]}
                  onChange={value => localDispatch.onChange('selectedGrupoOperacao', value)}
                />
              </div>
              {state.selectedGrupoOperacao && (state.selectedGrupoOperacao.value === 'Inventario' || state.selectedGrupoOperacao.value === 'Avulso') &&
                (
                  <>
                    <div className="p-col-3">
                      <CustomMultiSelect
                        marginTop={9}
                        label={'Operação de Estoque'}
                        optionLabel={'name'}
                        value={state.selectedOperacaoEstoque}
                        options={state.operacoesEstoqueFiltered}
                        onChange={value => localDispatch.onChange('selectedOperacaoEstoque', value)}
                      />
                    </div>
                    < div className="p-col-3">
                      <CustomMultiSelect
                        marginTop={9}
                        label={'Estoque'}
                        optionLabel={'name'}
                        value={state.selectedEstoque}
                        options={state.estoquesOptions}
                        onChange={value => localDispatch.onChange('selectedEstoque', value)}
                      />
                    </div>
                  </>)}
              <div className="p-col-12" style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap', gap: '8px' }}>
                <Periodo
                  periodoInicial={state.periodo.dataInicial}
                  periodoFinal={state.periodo.dataFinal}
                  textPesquisar="Procurar"
                  onPesquisar={(pInicial, pFinal) =>
                    localDispatch.getMovimentacaoPorTipoOperacao(
                      selectedTp,
                      state.selectedGrupoOperacao,
                      state.selectedEmpresa,
                      pInicial,
                      pFinal,
                      state.selectedOperacaoEstoque,
                      state.selectedEstoque
                    )
                  }
                />
                <div style={{ flexShrink: 0 }}>
                  <SplitButton
                    className="bck-primary"
                    label="Exportar Excel"
                    onClick={onExportExcel}
                    model={exportItems}
                  />
                </div>
              </div>
              <div className="p-col-12">
                <div style={{ marginTop: 15 }}>
                  {switchTypeDatatable(state.selectedGrupoOperacao)}
                </div>
              </div>
            </div>
          </React.Fragment>
        </CustomPanel>
      </div>
    </div >
  )
}

function DataTableOperacaoEntrada({ state, localDispatch }) {
  return (
    <DataTable
      header={
        <CustomDataTableHeader
          onChange={value => localDispatch.onChange('globalFilter', value)}
          value={state.globalFilter}
        />
      }
      rows={10}
      paginator={true}
      globalFilter={state.globalFilter}
      value={state.rows}
      emptyMessage="Não existem informações para a operação selecionada."
    >
      <Column field="data_movimentacao" header="Data da Operação" style={tableCellCentered()} />
      <Column field="invoice_number" header="Numero NF" style={tableCellCentered(120)} />
      <Column field="qte_volumes" header="Qte Volumes" style={tableCellCentered(70)} />
      <Column field="qte_pallets" header="Qte Pallet" style={tableCellCentered(70)} />
      <Column
        field="qte_pallets_remontado"
        header="Qte Pallet Remontado"
        style={tableCellCentered(70)}
      />
      <Column
        body={row => <NumeroDecimal>{row.peso_total}</NumeroDecimal>}
        field="peso_total"
        header="Peso Total em KG"
        style={tableCellCentered(70)}
      />
      <Column field="placa" header="Placa" style={tableCellCentered(150)} />
    </DataTable>
  )
}

function DataTableOperacaoExpedicao({ state, localDispatch }) {
  return (
    <DataTable
      header={
        <CustomDataTableHeader
          onChange={value => localDispatch.onChange('globalFilter', value)}
          value={state.globalFilter}
        />
      }
      rows={10}
      paginator={true}
      globalFilter={state.globalFilter}
      value={state.rows}
      emptyMessage="Não existem informações para a operação selecionada."
    >
      <Column field="data_operacao" header="Data da Operação" style={tableCellCentered()} />
      <Column
        field="carga_batida"
        header="Carga Batida"
        style={tableCellCentered(120)}
        body={item => <span>{item.carga_batida ? 'Sim' : 'Não'}</span>}
      />
      <Column field="identifier" header="Identificador" style={tableCellCentered(70)} />
      <Column field="qte_volumes" header="Qte Volumes" style={tableCellCentered(70)} />
      <Column field="qte_pallets" header="Qte Pallets" style={tableCellCentered(70)} />
      <Column
        body={row => <NumeroDecimal>{row.peso_total}</NumeroDecimal>}
        field="peso_total"
        header="Peso Total em KG"
        style={tableCellCentered(70)}
      />
    </DataTable>
  )
}

function DataTableOperacaoInventarioAvulso({ state, localDispatch }) {
  return (
    <DataTable
      header={
        <CustomDataTableHeader
          onChange={value => localDispatch.onChange('globalFilter', value)}
          value={state.globalFilter}
        />
      }
      rows={10}
      paginator={true}
      globalFilter={state.globalFilter}
      value={state.rows}
      emptyMessage="Não existem informações para a operação selecionada."
    >
      <Column field="data_movimentacao" header="Data da Operação" style={tableCellCentered()} />
      <Column field="product_name" header="Produto" style={tableCellCentered()} />
      <Column field="data_validade" header="Data de Validade" style={tableCellCentered()} />
      <Column field="lote" header="Lote" style={tableCellCentered()} />
      <Column field="operacao_name" header="Operação de Estoque" style={tableCellCentered()} />
      <Column field="estoque_name" header="Estoque" style={tableCellCentered()} />
      <Column
        body={row => <NumeroDecimal>{row.quantidade}</NumeroDecimal>}
        field="quantidade"
        header="Quantidade"
        style={tableCellCentered()}
      />
    </DataTable>
  )
}


const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MovimentacaoPorTipoOperacao))
